import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from '../auth.service';
import { UserDto } from '../user.dto';

@Directive({
  selector: '[appOnlyGroups]',
})
export class OnlyGroupsDirective implements OnInit, OnDestroy {
  @Input('appOnlyGroups') public groups: string[];
  private readonly destroy$: Subject<void> = new Subject();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private readonly authService: AuthService,
  ) {}

  public async ngOnInit(): Promise<void> {
    const user: UserDto | undefined = await this.authService.getUser();
    if (!user) {
      this.viewContainer.clear();
    }
    let authorized: boolean = false;

    if (user?.groups?.length > 0) {
      authorized = user.groups.some((userGroup: string) => this.groups.includes(userGroup));
    }
    if (authorized) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
